<section class="inner-page-section">
    <div class="container">
        <h1>ABOUT</h1>
        <h3>Created by a world-leading maritime consultant to serve all shipping professionals with unprecedented
            transparency</h3>
        <p>ENL Solutions was created specifically to provide shippers, freight forwarders, port operators and suppliers
            with complete daily and planned shipping schedules and rates for PCTC/RO-RO cargo. </p>
        <h3>All the information you need for transformational increases in performance</h3>
        <p>Whether you’re a shipper, freight forwarder, port operator or supplier, you’ll find membership in ENL
            Solutions offers you benefits that empower you to achieve transformational increases in performance. </p>
        <ul>
            <li>For the first time ever, you’ll enjoy on-demand access to the shipping schedules and rates of 12 major
                PCTC/RO shipping lines, which operate over 450 vessels and make approximately 10,000 port calls. And you
                can depend on the data to be comprehensive and accurate, because it’s updated daily.
                As a result, you’ll have the shipping information you need to operate more effectively and efficiently
                than ever.</li>
            <li>As a shipper, you’ll be able to see transparent shipping schedules and rates in one convenient place and
                choose freight forwarders to provide a quote. </li>
            <li>As a freight forwarder, you’ll appear in searches by far more shippers, so you can attract lots of new
                customers you wouldn’t otherwise be able to connect with. </li>
            <li>And as a port operator or supplier, you’ll have complete global view of shipping volumes, so you can
                manage you port and assets to drive performance to new levels. </li>
        </ul>
        <h3 class="mb-3">Founded by a maritime consultant to offer industry professionals breakthrough benefits</h3>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <img src="../../../assets/images/Endre_Lekven.jpg" alt="">
                <p><small><i>Capt. Endre Lekven, Founder & Maritime Consultant</i></small></p>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <p>Endre Lekven is a leading maritime consultant with a focus on innovative solutions. </p>
                <p>He has over 25 years of experience working with major shipping lines. </p>
                <p>He established Endre Lekven As, as a consultancy to provide shipping companies with supercargo services,
                    marine surveying, and project management. </p>
                <p>He currently consults with a number of shipping companies, advising them on the PCTC market, PCTC vessel
                    standards and requirements, operational efficiency in ports, use of cargo equipment, and common practices in
                    cargo handling. </p>
                <p>He also acts as a travelling cargo superintendent and vessel operator.</p>
            </div>
        </div>
               
        <h3>Areas of special expertise </h3>
        <p>Endre has broad international experience in:</p>
        <ul>
            <li>Implementing and maintaining shipping programs for operational efficiency</li>
            <li>Establishing systems to monitor the performance of vessels and suppliers, with the development of KPI’s
            </li>
            <li>Verifying the performance of ship operators</li>
            <li>Performing quality audits of ports and terminals for ship owners and classification societies</li>
            <li>Consulting in vessel operation and efficiency, including cargo operations and inspections</li>
        </ul>
        <p>Always intent on informed innovation, he independently developed and sold a system for Ro-Ro business
            analytics.</p>

        <h3>Education</h3>
        <p>Lloyds Maritime Academy<br />
            Diploma in Marine Surveying<br />
            Norwegian Business Academy<br />
            Business management<br />
            Croftholmen Maritime Academy <br />
            <strong>Maritime education: Nautical class 1</strong><br />
            Phoenix East Aviation, Daytona Beach, Florida, USA<br />
            Commercial Pilot/Flight Instructor</p>

        <h3>Personal life</h3>
        <p>Endre is Norwegian, married, and the father of 2 children.</p>

        <h3>Prior Positions </h3>
        <p>Wallenius Wilhelmsen Logistics<br />
            <strong>Operational Efficiency Manager, Global Operations<br />
                Category Manager, Stevedoring and Global Procurement</strong><br />
            <i>Hoegh Autoliners</i><br />
            Senior Manager, Port Services, Europe<br />
            Purchasing/Quality Manager Europe<br />
            Cargo Handling Manager<br />
            Owners Representative, Southern Africa and Indian Ocean<br />
            Port Captain/Supercargo<br />
            Prior to his executive positions, Endre did seagoing time on a shuttle tanker and product tankers as an
            ordinary seaman and then as a deck officer. He has also worked as a charter pilot & flight instructor in
            Kentucky, USA</p>
    </div>
</section>